<template>
  <dd-dashboard-header-page header="Takenreeksen">
    <template #header-buttons>
      <dd-button :href="route('vue.dashboard.task_lists.create')">
        Takenreeks starten
      </dd-button>
    </template>
    <template #content>
      <dd-container>
        <dd-card wide-content>
          <div class="flex-col gap-md">
            <div class="flex-row gap-md p-md align-items-end">
              <dd-customer-select
                name="customer_id"
                title="Klant kiezen"
                data-dusk="task-customer"
                searchable
                :value="filter.customer_id"
                @input="
                  (event) => {
                    filter.customer_id = event;
                    loadPageObject.page = 1;

                    loadPage();
                  }
                "
                style="min-width: 300px"
              ></dd-customer-select>
              <dd-select
                title="Takenreeks template"
                label="Kies een takenreeks template"
                :options="getTaskListTemplates"
                :value="filter.task_list_template_id"
                @input="
                  (event) => {
                    filter.task_list_template_id = event;
                    loadPageObject.page = 1;

                    loadPage();
                  }
                "
                style="min-width: 300px"
              ></dd-select>

              <dd-icon-button
                icon="mdi mdi-close"
                @click="
                  () => {
                    filter.task_list_template_id = null;
                    filter.customer_id = null;

                    loadPage();
                  }
                "
              ></dd-icon-button>
            </div>
            <dd-main-table
              :loading="loading"
              :has-select="false"
              :rows="taskLists"
              :headers="headers"
              :paginator="paginator"
              :initial-load-page-object="loadPageObject"
              @load-page="(pageObject) => onLoadPage(pageObject)"
              action-width="200px"
            >
              <template #actions="{ row }">
                <div class="flex-row align-items-center gap-md">
                  <dd-button @click="showDetails(row.id)"> Details</dd-button>
                </div>
              </template>
            </dd-main-table>
          </div>

          <ShowTaskListDrawer @update="updateTaskList" ref="drawer"></ShowTaskListDrawer>
        </dd-card>
      </dd-container>
    </template>
  </dd-dashboard-header-page>
</template>

<script>
import taskListApi from "~/api/task_list";
import ShowTaskListDrawer from "~/modules/task_list/components/ShowTaskListDrawer.vue";
import TaskCompletedCell from "~/modules/task_list/components/TaskCompletedCell.vue";
import taskListTemplateApi from "~/api/task_list_template";

export default {
  data() {
    return {
      taskLists: null,
      headers: [
        {
          title: "Klant",
          key: "customer_name",
          width: "300px",
        },
        {
          title: "Naam",
          key: "name",
          width: "200px"
        },
        {
          title: "Status",
          width: "200px",
          key: "task_statuses",
          typeComponent: TaskCompletedCell,
        },
      ],
      loadPageObject: {
        page: 1,
        perPage: 15,
      },
      paginator: null,
      filter: {
        customer_id: null,
        task_list_template_id: null,
      },
      taskListTemplates: [],
      loading: false,
    };
  },
  components: {
    ShowTaskListDrawer,
  },
  mounted() {
    this.loadPage();

    this.fetchTaskListTemplates();
  },
  methods: {
    async loadPage() {
      this.loading = true;
      let response = await taskListApi.paginate(
        this.loadPageObject?.page,
        this.loadPageObject?.perPage,
        this.filter
      );

      this.taskLists = response.data;
      this.paginator = response.meta.pagination;
      this.loading = false;
    },
    onLoadPage(pageObject) {
      this.loadPageObject = pageObject;
      this.loadPage();
    },
    showDetails(taskListId) {
      this.$refs.drawer.viewTaskList(taskListId);
    },
    async fetchTaskListTemplates() {
      let response = await taskListTemplateApi.all();

      this.taskListTemplates = response.taskListTemplates;
    },
    updateTaskList(updatedTaskList) {
      let index = this.taskLists.findIndex(t => t.id === updatedTaskList.id);

      this.$set(this.taskLists, index, updatedTaskList);
    }
  },
  computed: {
    getTaskListTemplates() {
      return this.taskListTemplates.map((taskListTemplate) => {
        return {
          value: taskListTemplate.id,
          label: taskListTemplate.name,
        };
      });
    },
  },
};
</script>

<style scoped></style>
